import React, { useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { useAuthentication } from '@redux/authentication/hook'

import { MODULE_GUID } from '@utils/constant'

const menuList = [
  {
    path: "post",
    moduleGuid: MODULE_GUID.POST,
  },
  {
    path: "applications",
    moduleGuid: MODULE_GUID.APPLICATION,
  },
  {
    path: "activity-payment",
    moduleGuid: MODULE_GUID.PAYMENT,
  },
  {
    path: "broadcasts",
    moduleGuid: MODULE_GUID.BROADCAST,
  },
  {
    path: "banner-setup",
    moduleGuid: MODULE_GUID.SETUP,
  },
  {
    path: "security",
    moduleGuid: MODULE_GUID.SECURITY,
  },
  {
    path: "inquiries",
    moduleGuid: MODULE_GUID.INQUIRY,
  },
  {
    path: "section-1",
    moduleGuid: MODULE_GUID.ABOUT_US,
  },
];

export default function Dashboard() {
  const navigate = useNavigate()
  const { moduleAccess } = useAuthentication()

  useEffect(()=> {
    const matchedMenu = menuList.find(menu =>
      moduleAccess.some(m => m.moduleGuid === menu.moduleGuid)
    );
    if(matchedMenu){
      navigate(`/admin/${matchedMenu?.path}`, {replace: true})
    }
  },[moduleAccess])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    }}
    >
    <CircularProgress disableShrink/>
    </div>
  )
}
